import jwt from 'jwt-decode';

export const getSessionToken = (): string | null =>
  localStorage.getItem('session-token');

export const decodeToken = (token: string) => {
  return jwt(token);
};
